<template>
  <div class="video-content">
    <!--顶部信息 + 推荐视频-->
    <headerItem />
    <!--相关up主推荐-->
    <uploaderRecommend />
  </div>
</template>

<script>
import pageExpose from '../common/mixins/pageExpose';
import headerItem from './components/headerItem.vue';
import uploaderRecommend from './components/uploaderRecom.vue';

export default {
  components: {
    headerItem,
    uploaderRecommend,
  },
  mixins: [pageExpose],
  asyncData({ context, store, route }) {
    return store
      .dispatch('uploader/prefetchData', { context, route })
      .catch(err => console.log('[UPLOADER_ERROR]', err));
  },
};
</script>

<style>
@import '../common/css/video.css';
</style>
